var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    { class: ["list-alert", { unread: _setup.isNotReadAlert }] },
    [
      _c(
        "div",
        {
          staticClass: "alert-info",
          on: {
            click: function ($event) {
              return _setup.goToAlert(_setup.props.alert)
            },
          },
        },
        [
          _c("span", {
            class: [_setup.props.alert.icon, "lf-icon__lg", "icon"],
          }),
          _c("div", { staticClass: "item-info" }, [
            _c("span", { staticClass: "alert-text" }, [
              _vm._v(_vm._s(_setup.props.alert.message)),
            ]),
            _c("span", { staticClass: "alert-date" }, [
              _vm._v(_vm._s(_setup.expiredDate)),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "icons-container" },
        [
          _c(_setup.LexonTooltipComponent, {
            attrs: {
              icon: _setup.AlertsMessageVisibilityIcons[
                _setup.props.alert.visibility
              ],
              message: _setup.isNotReadAlert
                ? _setup.texts.read
                : _setup.texts.noRead,
              position: "top",
              action: () => _setup.onClickToggleRead(_setup.props.alert),
            },
          }),
          _c(_setup.LexonTooltipComponent, {
            attrs: {
              icon: _setup.Icons.CHECK_ROUND,
              message: _setup.texts.realized,
              position: "top",
              action: () => _setup.onClickDone(_setup.props.alert),
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }